import React from "react";

const ConfirmEmailLogo: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={47}
    viewBox="0 0 47 47"
    fill="none"
    {...props}
  >
    <path
      d="M31.335 15.667v9.791a5.875 5.875 0 1011.75 0V23.5a19.584 19.584 0 10-7.677 15.55M31.335 23.5a7.833 7.833 0 11-15.667 0 7.833 7.833 0 0115.667 0z"
      stroke="#8065C9"
      strokeWidth={3.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ConfirmEmailLogo;
